import React from 'react';

class ProjectInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className="mole__project--info fulLW">
                <div className="main-container">
                    <div className="inner-container">
                        <h2 className="font-lg">Static Project</h2>
                        <article className="--caption font-lg w-100 c-general">
                            A collaboratively designed
                            cohousing scheme, created
                            from low-energy passive design
                            principles and an innovative
                            custom-build strategy.
                        </article>
                    </div>
                </div>
            </section>    
        );
    }
}
export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/components/Projects/Details/ProjectInfo.js